import { Dayjs } from "dayjs";
import {
  LocationExceptionalStatusRead,
  ReviewPeriodData,
} from "src/store/api/generatedApi";
import { ExceptionalStatusMarkers } from "./ExceptionalStatusMarkers";
import { LoadingInterval } from "./locationLoadingIntervals";
import { LocationLoadingStrip } from "./LocationLoadingStrip";
import { ReviewPeriodMarkers } from "./ReviewPeriodMarkers";
import { COLLAPSED_LANE } from "./timelineLayout";

interface CollapsedLocationLaneProps {
  reviewPeriods: ReviewPeriodData[];
  exceptionalStatuses: LocationExceptionalStatusRead[];
  loadingIntervals: readonly LoadingInterval[];
  getPositionPercent: (time: Dayjs) => number;
}

export const CollapsedLocationLane = ({
  reviewPeriods,
  exceptionalStatuses,
  loadingIntervals,
  getPositionPercent,
}: CollapsedLocationLaneProps) => (
  <>
    <ReviewPeriodMarkers
      reviewPeriods={reviewPeriods}
      slot={COLLAPSED_LANE.reviewPeriods}
      getPositionPercent={getPositionPercent}
      suppressTooltip
    />
    <ExceptionalStatusMarkers
      exceptionalStatuses={exceptionalStatuses}
      slot={COLLAPSED_LANE.exceptionalStatuses}
      getPositionPercent={getPositionPercent}
      suppressTooltip
    />
    <LocationLoadingStrip
      intervals={loadingIntervals}
      slot={COLLAPSED_LANE.loading}
      getPositionPercent={getPositionPercent}
    />
  </>
);
